import React from 'react';
import './CsaePolicyPage.css';

const CsaePolicyPage = () => {
  return (
    <div className='csae-policy-container'>
      <header className='header'>
        <h1>WannaBAE Child Safety Standards</h1>
        <p>
          At WannaBAE, we are committed to fostering a safe and respectful
          community. Our policies strictly prohibit any form of child sexual
          abuse and exploitation (CSAE).
        </p>
      </header>

      <main className='main-content'>
        <section className='policy-section'>
          <h2>Our Zero-Tolerance Policy</h2>
          <p>
            WannaBAE has a zero-tolerance stance against child sexual abuse and
            exploitation, including but not limited to:
          </p>
          <ul>
            <li>
              Child sexual abuse material (CSAM), including images, videos, or
              text.
            </li>
            <li>
              Grooming or any attempt to exploit minors for sexual purposes.
            </li>
            <li>Sextortion or coercion involving minors.</li>
            <li>
              Trafficking or any activity endangering the safety of children.
            </li>
          </ul>
          <p>
            Any user found violating these standards will face immediate account
            suspension or termination, and we will report such incidents to the
            appropriate law enforcement authorities as required by law.
          </p>
        </section>

        <section className='policy-section'>
          <h2>How We Enforce Safety</h2>
          <p>
            We employ a combination of automated tools, human moderation, and
            user reporting mechanisms to identify and remove content or behavior
            that violates our CSAE policies. Our team works diligently to ensure
            WannaBAE remains a safe space for all users.
          </p>
        </section>

        <section className='policy-section'>
          <h2>Reporting Violations</h2>
          <p>
            If you encounter any content or behavior on WannaBAE that you
            believe violates our child safety standards, please report it
            immediately through the app or contact our Child Safety Officer at{' '}
            <a href='mailto:safety@wannabae.com'>safety@wannabae.com</a>. We
            take all reports seriously and act promptly to investigate and
            address them.
          </p>
        </section>

        <section className='policy-section'>
          <h2>Contact Us</h2>
          <p>
            For any inquiries or concerns related to child safety on WannaBAE,
            please reach out to our dedicated Child Safety Officer:
          </p>
          <p>
            <strong>Email:</strong>{' '}
            <a href='mailto:safety@wannabae.com'>safety@wannabae.com</a>
          </p>
        </section>
      </main>

      <footer className='footer'>
        <p>
          This Child Safety Standards page is part of WannaBAE’s commitment to
          user safety. For more details, see our{' '}
          <a href='https://www.wannabae.com/privacy-policy'>Privacy Policy</a>{' '}
          or <a href='https://www.wannabae.com/terms'>Terms of Service</a>.
        </p>
      </footer>
    </div>
  );
};

export default CsaePolicyPage;
